import $ from 'jquery';

import { $Elements, Classes, Elements, Events } from '../global/constants';
import { ajax } from '../global/helpers';

$Elements.document.on(Events.page.enter, () => {

    // ---------- Ajax Etudes Contact ----------

    if (typeof ajax_etudes_params !== 'undefined') {

        // When the modal is shown, check if the body has a data-etude attribute
        $('#contactModal').on('show.bs.modal', function() {
            const body = document.body;

            // Check if the body has a data-etude attribute
            if (body.hasAttribute('data-etude')) {
                // Extract the etude ID from the data-etude attribute
                const etudeId = body.getAttribute('data-etude');

                if (etudeId) {
                    // Select the corresponding option in the dropdown
                    const select = $('#etudeSelect');
                    select.val(etudeId);

                    // Trigger the change event to load the contact information
                    select.trigger('change');
                }
            }
        });

        // When the modal is hidden, reset the query
        $('#contactModal').on('hidden.bs.modal', function() {
            // Reset the dropdown selection
            const select = $('#etudeSelect');
            select.val('');

            // Reset contact info
            const contactInfo = $('#etudeContactInfo');
            contactInfo.html('<p class="text-center">' + ajax_etudes_params.select_text + '</p>');
        });

        $('#etudeSelect').on('change', async function() {
            const etudeId = $(this).val();
            const contactInfo = $('#etudeContactInfo');

            if (etudeId) {
                // Show loading indicator
                contactInfo.html('<p class="text-center">' + ajax_etudes_params.loading_text + '</p>');
                Elements.LoadingBar.classList.add(Classes.loading);

                const formData = new FormData();
                formData.append('action', ajax_etudes_params.action);
                formData.append('etude_id', etudeId);
                formData.append('nonce', ajax_etudes_params.nonce);

                try {
                    const response = await ajax({
                        url: ajax_etudes_params.url,
                        type: 'POST',
                        dataType: 'json',
                        data: formData,
                        processData: false,
                        contentType: false,
                    });

                    if (response.data.content) {
                        contactInfo.html(response.data.content);
                    } else {
                        contactInfo.html('<p class="text-center text-danger">' + ajax_etudes_params.error_text + '</p>');
                    }

                    $Elements.window.trigger(Events.animation.refresh);
                    $Elements.window.trigger(Events.resize);
                } catch (e) {
                    contactInfo.html('<p class="text-center text-danger">' + ajax_etudes_params.error_text + '</p>');
                }

                Elements.LoadingBar.classList.remove(Classes.loading);
            } else {
                // Reset contact info if no etude is selected
                contactInfo.html('<p class="text-center">' + ajax_etudes_params.select_text + '</p>');
            }
        });
    }
});
